exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".uib-datepicker .uib-title{width:100%}.uib-day button,.uib-month button,.uib-year button{min-width:100%}.uib-left,.uib-right{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/angular-ui-bootstrap/src/datepicker/datepicker.css
// module id = 1082
// module chunks = 1